import * as React from 'react';
import TransactionPageView from '../layouts/TransactionPageView';

export interface TransactionPageLayoutProps {
    returnTransactionId: string;
    returnTransactionStatus: boolean;
    paymentStatus: string;
    payuid: string;
    txnamt: string;
    axperror: string;
    goBack(location: string): void;
}

class TransactionPageComponent extends React.Component<TransactionPageLayoutProps> {
    render() {
        return (
            <div>
                <TransactionPageView
                    returnTransactionId={this.props.returnTransactionId}
                    returnTransactionStatus={this.props.returnTransactionStatus}
                    paymentStatus={this.props.paymentStatus}
                    payuid={this.props.payuid}
                    txnamt={this.props.txnamt}
                    axperror={this.props.axperror}
                    goBack={this.props.goBack}
                />
            </div>

        );
    }
    // componentDidMount() {
    // //   this.props.onComponentDidMount();
    // }
}

export default TransactionPageComponent;



// WEBPACK FOOTER //
// ./src/components/TransactionPage/TransactionPageComponent.tsx